<template>
  <div class="sscontent">
    <titlebar :titleName="$route.params.name" goback="true"></titlebar>
    <div class="content">
        <ul>
            <li class="item" v-for="(item,index) in 3" :key="index">
                <p class="time">
                    01月12日 
                </p>
                <div class="info">
                    <p class="title1">版本更新提醒</p>
                    <p class="title2">六一游趣2.1.1版本更新内容</p>
                    <van-divider />
                    <p class="title3">查看详情</p>
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import apiFun from "../../servers/apiFun";
import comTool from "../../assets/js/until";
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
};
</script>

<style lang="less"  scoped>
.content{
    padding-top: 13vw;
    .item{
        margin-top: 5vw;
        .time{
            color: #999;
            font-size: 3.5vw;
        }
        .info{
            width: 92vw;
            height: 25.8vw;
            background: #fff;
            border-radius: 3vw;
            margin: 0 auto;
            margin-top: 4vw;
            padding: 3.6vw 3.0667vw 2.2667vw 3.0667vw;
            text-align: left;
            .van-divider{
                margin: 3vw 0 2vw 0;
            }
            .title1{
                font-size: 4vw;
                color: #000;
                font-weight: 600;
                
            }
            .title2{
                font-size: 3vw;
                margin-top: 2vw;
            }
            .title3{
                font-size: 3vw;
                text-align: center;
                color: #000;
            }
        }
    }
}
</style>